export default __webpack_public_path__ + "static/media/p7.b0a9a05d.png";